<template>
  <section class="legal-agreement-container">
    <!-- ToC Modal -->
    <base-modal id="tos-modal" :closeVisible="false">
      <button class="btn btn-primary float-right mt-2" @click="agreeTosButton">{{ $t('legalAgreement.agree') }}</button>
      <div class="pdf-container" v-html="termsOfService"></div>
      <button class="btn btn-primary float-right mb-2" @click="agreeTosButton">{{ $t('legalAgreement.agree') }}</button>
    </base-modal>
    <!-- Privacy Policy Modal -->
    <base-modal id="pp-modal" :closeVisible="false">
      <button class="btn btn-primary float-right mt-2" @click="agreePpButton">{{ $t('legalAgreement.agree') }}</button>
      <div class="pdf-container" v-html="privacyPolicy"></div>
      <button class="btn btn-primary float-right mb-2" @click="agreePpButton">{{ $t('legalAgreement.agree') }}</button>
    </base-modal>
    <!-- Reset Password Modal -->
    <reset-password-modal id="reset-password-modal" :closeVisible="false" :redirectHome="true"></reset-password-modal>
  </section>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import { updateApi } from '@/services/api.service';
import BaseModal from '@/components/base-modal/base-modal.vue';
import ResetPasswordModal from '@/components/reset-password-modal/reset-password-modal.vue';
import common from "@/mixins/common";

export default {
  name: 'LegalAgreement',
  mixins: [common],
  components: {
    ResetPasswordModal,
    BaseModal,
  },
  computed: {
    ...mapState(['currentUser', 'currentMember', 'defaultOrganization']),
    ...mapGetters(['termsOfService', 'privacyPolicy']),
  },
  mounted() {
    if (!this.currentMember.attributes.accepted_terms_of_service_at) {
      this.openModal('tos-modal');
    } else if (!this.currentMember.attributes.accepted_privacy_policy_at) {
      this.openModal('pp-modal');
    } else if (this.currentUser.data.attributes.is_new === true) {
      this.openModal('reset-password-modal');
    } else {
      this.safelyNavigateToPath('Home');
    }
  },
  methods: {
    ...mapMutations(['setCurrentMember']),
    agreeTosButton() {
      const params = {
        data: {
          attributes: {
            accepted_terms_of_service_at: new Date(),
          },
        },
      };
      updateApi(`members/${this.currentMember.id}`, params)
        .then(({ data }) => {
          this.closeModal('tos-modal');
          if (!data.data.attributes.accepted_privacy_policy_at) {
            this.openModal('pp-modal');
          } else if (this.currentUser.data.attributes.is_new === true) {
            this.openModal('reset-password-modal');
          } else {
            this.safelyNavigateToPath('Home');
          }
        });
    },
    agreePpButton() {
      const params = {
        data: {
          attributes: {
            accepted_privacy_policy_at: new Date(),
          },
        },
      };
      updateApi(`members/${this.currentMember.id}`, params)
        .then(({ data }) => {
          this.closeModal('pp-modal');
          if (!data.data.attributes.accepted_terms_of_service_at) {
            this.openModal('tos-modal');
          } else if (this.currentUser.data.attributes.is_new === true) {
            this.openModal('reset-password-modal');
          } else {
            this.safelyNavigateToPath('Home');
          }
        });
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">

</style>
